export default "__VITE_ASSET__DuA3ybwW__"